<ui-card type="clear">
    <card-header class="bordered px-0 py-2 flex-direction-column align-items-stretch">
        <div class="card-details px-4 py-2">
            <h3 id="h3_1616396275" class="regular ellipsis" [innerHTML]="menu.owner.firstname"></h3>
            <div id="div_1616396302" class="color-shade-60 ellipsis">{{ menu.owner.email }}</div>
        </div>

        <ui-list class="unbordered" size="lg" *ngIf="menu.owner.groups.length">
            <ui-list-item *ngFor="let context of contextsInterface; let i = index"
                class="px-4"
                [ngClass]="context.current ? 'active bg-primary-5': 'color-shade-50'">
                <div>
                    <span id="span_1712728654_{{i}}" class="h5">{{context.contextLabel | translate}}</span>
                    <div class="color-shade-50 word-break">
                        <p id="span_1712728655_{{i}}" class="m-0 c1 d-inline" *ngIf="context.showGroupLabel && context.groupLabel">{{context.groupLabel}}</p>
                        <p id="span_1712728656_{{i}}" class="m-0 c1 d-inline" *ngIf="context.roleLabel">&nbsp;&bull; {{context.roleLabel | translate}}</p>
                    </div>
                </div>
                <div class="ml-auto text-center">
                    <ui-icon type="general" icon="mark" *ngIf="context.current; else switchContextCta"></ui-icon>
                    <ng-template #switchContextCta>
                        <button id="span_1712728657_{{i}}" ui-button model="link" color="primary" (click)="switchContext(context.contextId)">
                            {{'group.context.cta.switch' | translate}}
                        </button>
                    </ng-template>
                </div>
            </ui-list-item>
        </ui-list>
    </card-header>

    <card-body class="card-body px-0 py-2">
        <ui-list class="default unbordered" size="lg" [highlights]="true">
            <ng-container *ngFor="let listItem of menu.list; let i = index">
                <a id="a_1602657015_{{i}}" [href]="listItem.url" *ngIf="listItem.display" ui-list-item (click)="listItem.action($event)" class="px-4" [title]="listItem.label">
                    <span class="icon {{ listItem.icon }}"></span><span class="details">{{ listItem.label }}</span>
                </a>
            </ng-container>
        </ui-list>
    </card-body>

    <card-footer *ngIf="configService.config.themes" class="bordered p-4 mt-auto">
        <switch-control>
            <input id="input_1643221696" type="checkbox" [checked]="themeSelected" (click)="toggleTheme()">
            <label for="input_1643221696">Enable dark theme</label>
        </switch-control>
    </card-footer>

</ui-card>
